import { render, staticRenderFns } from "./SpecialQuestion.vue?vue&type=template&id=ee58a408&scoped=true"
import script from "./SpecialQuestion.vue?vue&type=script&lang=js"
export * from "./SpecialQuestion.vue?vue&type=script&lang=js"
import style0 from "./SpecialQuestion.vue?vue&type=style&index=0&id=ee58a408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee58a408",
  null
  
)

export default component.exports